/**
 * DÍAS HÁBILES en el navegador (dueño 2026-10-14): lo que una pantalla calcula sola (días en cola, días esperando)
 * cuenta lunes a viernes, igual que el servidor (`ppag_business_days`): desde el día de `desde` hasta el anterior al
 * de `hasta`, mismo día = 0, sin feriados. Los días se miden en el huso de la oficina.
 */
const TZ = 'America/New_York';
const DIA_MS = 86_400_000;
function diaOficina(d: Date): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
}
export function diasHabilesEntreFechas(a: string, b: string): number {
  const ta = Date.UTC(Number(a.slice(0, 4)), Number(a.slice(5, 7)) - 1, Number(a.slice(8, 10)));
  const tb = Date.UTC(Number(b.slice(0, 4)), Number(b.slice(5, 7)) - 1, Number(b.slice(8, 10)));
  if (!Number.isFinite(ta) || !Number.isFinite(tb) || tb <= ta) return 0;
  const total = Math.round((tb - ta) / DIA_MS);
  const semanas = Math.floor(total / 7);
  let n = semanas * 5;
  const dow0 = (new Date(ta).getUTCDay() + 6) % 7;
  for (let k = semanas * 7; k < total; k++) if ((dow0 + k) % 7 < 5) n++;
  return n;
}
/** Días hábiles desde un instante hasta ahora (o hasta `hasta`). null/inválido → null. */
export function diasHabilesDesde(desde: string | number | Date | null | undefined, hasta: Date | number = Date.now()): number | null {
  if (desde == null) return null;
  const d = new Date(desde);
  if (Number.isNaN(d.getTime())) return null;
  return diasHabilesEntreFechas(diaOficina(d), diaOficina(new Date(hasta)));
}
